<template>
  <div>
    <a-row>
      <a-col :span="2">
        医疗机构：
      </a-col>
      <a-col :span="4">
        <a-input v-model.trim="compId" />
      </a-col>

      <a-col :span="2">
        医废接收日期:
      </a-col>
      <a-col :span="4">
        <a-input v-model.trim="AcceptDate_Begin" />
        <!-- <my-date
          :date-value.sync="AcceptDate_Begin"
          :placeholder="'接收开始时间'"
        /> -->
      </a-col>
      <!-- <a-col :span="2">
        接收结束时间
      </a-col> -->
      <!-- <a-col :span="4">
        <my-date
          :date-value.sync="AcceptDate_End"
          :placeholder="'接收结束时间'"
        /> -->
      <!-- </a-col> -->
      <a-col :span="2">
        <a-button type="primary" @click="look">
          查询
        </a-button>
      </a-col>
      <a-col :span="2">
        <a-button type="primary" @click="lookAdd">
          添加
        </a-button>
      </a-col>
      <a-col :span="2">
        <a-button type="primary" @click="batchEdit">
          批量修改
        </a-button>
      </a-col>
    </a-row>
    <a-table
      :columns="columns"
      :data-source="data.data"
      bordered
      :scroll="{ y: '65vh' }"
      :pagination="false"
      rowKey="id"
    >
      <template slot="operation" slot-scope="text, record">
        <a @click="edit(record)">修改</a>
        <a-divider type="vertical" />
        <a style="color:red" @click="del(record)">删除</a>
      </template>
    </a-table>
    <my-page :data="data" @change="onChange" />
    <a-modal
      v-model="delVisible"
      title="提示"
      width="400px"
      ok-text="确定"
      cancel-text="取消"
      @ok="delOk"
      @cancel="cancel"
    >
      <a class="Tips">是否确定删除!</a>
    </a-modal>

    <!-- 修改 -->
    <a-modal
      v-model="editVisible"
      title="编辑数据"
      width="600px"
      ok-text="确定"
      cancel-text="取消"
      @ok="editOk"
      @cancel="editcancel"
    >
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="医疗类别：">
          <a-select v-model="form.type" style="width: 195px">
            <a-select-option value="1">
              感染类
            </a-select-option>
            <a-select-option value="2">
              损伤类
            </a-select-option>
            <a-select-option value="3">
              病理类
            </a-select-option>
            <a-select-option value="4">
              特殊类
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="重量：">
          <a-input v-model.trim="form.weight" />
        </a-form-item>
        <a-form-item label="接受时间">
          <a-input v-model.trim="form.acceptDate" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 增加 -->
    <a-modal
      v-model="addVisible"
      title="增加数据"
      width="600px"
      ok-text="确定"
      cancel-text="取消"
      @ok="addOk"
      @cancel="addcancel"
    >
      <a-form
        :form="addForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-form-item label="医疗机构名称：">
          <a-input
            v-model.trim="addForm.compId"
            placeholder="输入医疗机构名称"
          />
        </a-form-item>
        <a-form-item label="医疗类别：">
          <a-select v-model="addForm.type" style="width: 195px">
            <a-select-option value="1">
              感染类
            </a-select-option>
            <a-select-option value="2">
              损伤类
            </a-select-option>
            <a-select-option value="3">
              病理类
            </a-select-option>
            <a-select-option value="4">
              特殊类
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="重量：">
          <a-input v-model.trim="addForm.weight" placeholder="重量" />
        </a-form-item>
        <a-form-item label="交货人员姓名：">
          <a-input
            v-model.trim="addForm.putUserName"
            placeholder="交货人员姓名"
          />
        </a-form-item>
        <a-form-item label="接收人员姓名：">
          <a-input
            v-model.trim="addForm.saveUserName"
            placeholder="接收人员姓名"
          />
        </a-form-item>
        <a-form-item label="接受时间">
          <my-datetime
            :date-value.sync="addForm.acceptDate"
            :placeholder="'接收日期时间'"
          />
          <!-- <a-input v-model.trim="addForm.acceptDate" placeholder="接收时间:yyyy-MM-dd HH:mm:ss"/> -->
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 批量修改 -->
    <!-- 增加 -->
    <a-modal
      v-model="batchVisible"
      title="批量修改"
      width="600px"
      ok-text="确定"
      cancel-text="取消"
      @ok="batchOk"
      @cancel="batchCancel"
    >
      <div style="color:#f20">提示:修改后不可撤销，请谨慎操作</div>
      <div style="height:10px"></div>
      <a-form
        :form="batchForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-item label="修改区域:">
          <a-select
            show-search
            placeholder="修改区域"
            option-filter-prop="children"
            style="width: 200px"
            v-model="batchForm.CityName"
          >
            <a-select-option
              :value="item"
              v-for="(item, i) of addressList"
              :key="i"
            >
              {{ item }}
            </a-select-option>
          </a-select>

          <!-- <a-input v-model.trim="batchForm.CityName" placeholder="修改区域" /> -->
        </a-form-item>
        <a-form-item label="修改医疗机构:">
          <a-input
            v-model.trim="batchForm.CompName"
            placeholder="修改医疗机构"
          />
        <div style="">医疗机构可空，不填则修改当前区域下的所有医疗机构数据</div>

        </a-form-item>
        <a-form-item label="原接收时间:">
          <!-- <a-input v-model.trim="batchForm.OldDate" placeholder="原接受时间" /> -->
          <!-- <my-datetime
            :date-value.sync="batchForm.OldDate"
            :placeholder="'原接受时间'"
          /> -->
            <a-date-picker v-model="batchForm.OldDate" @change="onChangeOldDate"   :placeholder="'原接收时间'" />
        </a-form-item>
        <a-form-item label="新接收时间:">
          <!-- <my-datetime
            :date-value.sync="batchForm.NewDate"
            :placeholder="'新接受时间'"
          /> -->
            <a-date-picker v-model="batchForm.NewDate" @change="onChangeNewDate"   :placeholder="'新接收时间'" />

          <!-- <a-input v-model.trim="addForm.acceptDate" placeholder="接收时间:yyyy-MM-dd HH:mm:ss"/> -->
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getNowDateString } from "../../config/Config";

import {
  queryList,
  dispose,
  deletedispose,
  getonedispose,
  updatedispose,
  pushdispose,
  UpdateByOrg,
} from "./js/ApiQuery";
import {getOrgQueryList} from '../basic/js/ApiBasic';

const columns = [
  // {
  //     title: '序号',
  //     dataIndex: 'orderNo',
  //     key: 'orderNo',
  //     ellipsis: true,
  // },
  {
    title: "医疗机构",
    dataIndex: "compId",
    key: "compId",
    ellipsis: true,
  },
  {
    title: "医废类别",
    dataIndex: "type",
    key: "type",
    ellipsis: true,
  },
  {
    title: "重量",
    dataIndex: "weight",
    key: "weight",
    ellipsis: true,
  },
  {
    title: "交货人",
    dataIndex: "putUserName",
    key: "putUserName",
    ellipsis: true,
  },
  {
    title: "接收人",
    dataIndex: "saveUserName",
    key: "saveUserName",
    ellipsis: true,
  },
  {
    title: "接收时间",
    dataIndex: "acceptDate",
    key: "acceptDate",
    ellipsis: true,
  },
  {
    title: "存储时间",
    dataIndex: "saveTime",
    key: "saveTime",
    ellipsis: true,
  },
  {
    title: "处置时间",
    dataIndex: "disposeTime",
    key: "disposeTime",
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  data() {
    return {
      columns,
      data: {},
      compId: "",
      state: "",
      AcceptDate_Begin: "",
      AcceptDate_End: "",
      DisposeTime_Begin: "",
      DisposeTime_End: "",
      delVisible: false,
      lineId: "",
      editVisible: false,
      form: {
        type: "",
        weight: "",
        acceptDate: "",
        id: "",
      },
      addVisible: false,
      addForm: {
        compId: "",
        putUserName: "",
        saveUserName: "",
        type: "",
        weight: "",
        state: "2",
        acceptDate: undefined,
      },
      batchVisible: false,
      batchForm: {
        CityName: undefined,
        CompName: "",
        OldDate: "",
        NewDate: "",
      },
      addressList: [],
    };
  },
  methods: {
    onChangeOldDate(date,dateString){
      this.batchForm.OldDate =dateString
    },
    onChangeNewDate(date,dateString){
      this.batchForm.NewDate =dateString
      
    },
    // 批量修改
    batchEdit() {
      let baseDto = {
        pageIndex: 1,
        pageSize: 99999,
      };
      getOrgQueryList({ baseDto: baseDto }).then((res) => {
        console.log(res);
        var addressArr = [];
        res.data.data.forEach((item) => {
          addressArr.push(item.address);
        });
        this.addressList = this.unique(addressArr);
      });
      this.batchVisible = true;
    },
    unique(arr) {
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
            if (newArr.indexOf(arr[i]) === -1) {
                newArr.push(arr[i]);
            }
        }
        return newArr;
    },
    //
    batchOk() {
      UpdateByOrg(this.batchForm).then((res) => {
        this.$message.success(res.message);
        this.batchCancel();
      });
      console.log(this.batchForm);
    },
    batchCancel() {
      this.batchForm = {
        CityName: undefined,
        CompName: "",
        OldDate: "",
        NewDate: "",
      };
      this.batchVisible = false;
    },

    edit(record) {
      getonedispose({ id: record.id }).then((res) => {
        switch (res.data.type) {
          case "感染类":
            this.form.type = "1";
            break;
          case "损伤类":
            this.form.type = "2";
            break;
          case "病理类":
            this.form.type = "3";
            break;
          case "特殊类":
            this.form.type = "4";
            break;
          default:
            break;
        }
        // this.form.type = res.data.type;
        this.form.weight = res.data.weight;
        this.form.id = res.data.id;
        this.form.acceptDate = res.data.acceptDate;
      });
      this.editVisible = true;
    },
    //   确认修改
    editOk() {
      console.log(this.form);
      this.form.weight = Number(this.form.weight);
      updatedispose(this.form).then(() => {
        this.editcancel();
        let baseDto = {
          pageIndex: 1,
          pageSize: 10,
          compId: this.compId,
          state: this.state,
          AcceptDate_Begin: this.AcceptDate_Begin,
          AcceptDate_End: this.AcceptDate_Begin,
          DisposeTime_Begin: this.DisposeTime_Begin,
          DisposeTime_End: this.DisposeTime_End,
        };
        this.getData({ baseDto: baseDto });
      });
    },
    editcancel() {
      this.form = {
        type: "",
        weight: "",
        id: "",
      };
      this.editVisible = false;
    },
    del(record) {
      this.delVisible = true;
      this.lineId = record.id;
    },
    delOk() {
      deletedispose({ id: this.lineId }).then(() => {
        this.$message.success("删除成功");
        this.cancel();
        let baseDto = {
          pageIndex: 1,
          pageSize: 10,
          compId: this.compId,
          state: this.state,
          AcceptDate_Begin: this.AcceptDate_Begin,
          AcceptDate_End: this.AcceptDate_Begin,
          DisposeTime_Begin: this.DisposeTime_Begin,
          DisposeTime_End: this.DisposeTime_End,
        };
        this.getData({ baseDto: baseDto });
      });
    },
    cancel() {
      this.delVisible = false;
    },
    // 处置
    dispose(text, record) {
      var obj = {
        id: record.id,
        disposeUser: record.disposeUser,
        desc: record.desc,
      };
      dispose(obj).then((res) => {
        if (res.status == 0) {
          this.look();
        }
      });
    },
    // 查看详情
    lookDetails(text, record) {
      console.log(record);
    },
    getData(parameter) {
      queryList(parameter).then((res) => {
        this.data = res.data;
      });
    },
    // 查询
    look() {
      let baseDto = {
        pageIndex: 1,
        pageSize: 10,
        compId: this.compId,
        state: this.state,
        AcceptDate_Begin: this.AcceptDate_Begin,
        AcceptDate_End: this.AcceptDate_Begin,
        DisposeTime_Begin: this.DisposeTime_Begin,
        DisposeTime_End: this.DisposeTime_End,
      };
      this.getData({ baseDto: baseDto });
    },
    //增加
    lookAdd() {
      this.addForm.weight = "";
      this.addForm.id = "";
      this.addForm.acceptDate = "";
      this.addVisible = true;
    },
    // 确认添加
    addOk() {
      console.log(this.addForm);
      this.addForm.state = "2";
      this.addForm.weight = Number(this.addForm.weight);
      pushdispose(this.addForm).then(() => {
        this.addcancel();
        let baseDto = {
          pageIndex: 1,
          pageSize: 10,
          compId: this.compId,
          state: this.state,
          AcceptDate_Begin: this.AcceptDate_Begin,
          AcceptDate_End: this.AcceptDate_Begin,
          DisposeTime_Begin: this.DisposeTime_Begin,
          DisposeTime_End: this.DisposeTime_End,
        };
        this.getData({ baseDto: baseDto });
      });
    },
    addcancel() {
      this.addForm = {
        type: "",
        weight: "",
        acceptDate: undefined,
      };
      this.addVisible = false;
    },
    // 分页
    onChange(page) {
      let baseDto = {
        pageIndex: page,
        pageSize: 10,
        compId: this.compId,
        state: this.state,
        AcceptDate_Begin: this.AcceptDate_Begin,
        AcceptDate_End: this.AcceptDate_Begin,
        DisposeTime_Begin: this.DisposeTime_Begin,
        DisposeTime_End: this.DisposeTime_End,
      };
      this.getData({ baseDto: baseDto });
    },
    getTime() {
      return getNowDateString();
    },
  },
  created() {
    this.AcceptDate_Begin = getNowDateString();
    let baseDto = {
      pageIndex: 1,
      pageSize: 10,
      compId: this.compId,
      state: this.state,
      AcceptDate_Begin: this.AcceptDate_Begin,
      AcceptDate_End: this.AcceptDate_Begin,
      DisposeTime_Begin: this.DisposeTime_Begin,
      DisposeTime_End: this.DisposeTime_End,
    };
    this.getData({ baseDto: baseDto });
  },
};
</script>

<style scoped></style>
